import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import {useParams, useSearchParams} from "react-router-dom";
import Footer from "../components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import TicketProcessBuy from "../components/Typeform/TicketProcessBuy";
import img_top from "../assets/Blog.jpg";
import TicketInfoComponent from "../components/Card/Ticket/TicketInfoComponent";
import Alert from "react-bootstrap/Alert";

function PurchaseTicket() {
    const {id} = useParams();
    const [area, setArea] = useState(null);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [ticket, setTicket] = useState();
    const [listPackages, setListPackages] = useState([]);
    const [error, setError] = useState(null);

    const advantages = searchParams.get("advantages") === "true"; // Ottiene il valore della query string
    useEffect(() => {
        if (typeof id === "undefined")
            return;
        fetch(global.route.ticketInfo, {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: id}
            )
        })
            .then(response => {
                response.json().then(res => {
                    if (response.status !== 200) {
                        if (typeof res.error !== "undefined")
                            setError(res.error);
                        setLoading(false);
                    } else {
                        document.title = "Geoticket - " + res.ticket.name;
                        setTicket(res.ticket);
                        setArea(res.area);
                        setListPackages(res.list_packages);
                        setLoading(false);
                    }
                });
            })

            .catch((error) => {
                setLoading(false);
            });
    }, [id]);

    let getTicket = () => {
        let result = [];
        result.push(<TicketProcessBuy ticket={ticket} listPackages={listPackages} withAdvantages={advantages}/>)
        return result;
    }

    let img_bg = img_top;
    let logo = null;
    if (area !== null) {
        if (area.image !== null) {
            img_bg = global.baseUrl + area.image;
        } else {
            img_bg = global.baseUrl + "/" + area.category.image;
        }
        if (area.logo !== null)
            logo = <div className={"logo"}><img src={global.baseUrl + area.logo}/></div>
    }
    if (area === null) {
        return (
            <div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
                <Header/>
                <div className="video-section">
                    <img className="background-video" src={img_bg}/>
                    <div className="overlay-content background">
                        <div>
                            <div className={"container"}>
                                <div style={{flex: 1}}>
                                    <h1 className="title">Acquisto permesso</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {error !== null ? <div className="container pt-2">
                    <Alert variant="danger">{error}</Alert>
                </div> : <></>}
                <Footer/>
            </div>);
    } else {
        return (<div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_bg}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                {logo}
                                <h1 className="title">{area.name}</h1>
                                <span>{area.address}, {area.number} {area.city} ({area.province})</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: "#EEEEEE"}}>
                <TicketInfoComponent ticket={ticket}/>
                <div className="container pt-4 pb-4">
                    <div className="row">
                        {getTicket()}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>);
    }
}

export default PurchaseTicket;